import { useQuery } from '@zg-rentals/react-query5';
import type { UseQueryResult } from '@zg-rentals/react-query5';
import { API, BASE_URL } from '../constants/urls';
import type { ApiResponseDto, RentalManagerAuthCheckUserInfoDto } from '@zg-rentals/ts-rental-manager-api-client';

export async function getUserData(requestUrl = ''): Promise<ApiResponseDto<RentalManagerAuthCheckUserInfoDto>> {
  const response = await fetch(requestUrl, { credentials: 'include' });
  if (!response.ok) {
    throw new Error('Failed to get user data');
  }
  return await response.json();
}

export default function useGetUser(): UseQueryResult<ApiResponseDto<RentalManagerAuthCheckUserInfoDto>, unknown> {
  const requestUrl = `${BASE_URL}${API.GET_USER}?pageWithSensitiveInformation=true`;
  return useQuery({
    queryKey: ['getUser'],
    queryFn: () => getUserData(requestUrl),
  });
}
